var _mask, _g, _mask2, _g2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPoliceman(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    fill: "none",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "9zgh2omw1a",
    width: 5,
    height: 11,
    x: 41,
    y: 40,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M41.337 40.782h4.098V50h-4.098v-9.218z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#9zgh2omw1a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6C7281",
    fillRule: "evenodd",
    d: "M44.356 41.837c-.273-.81-1.155-1.247-1.963-.974-.393.132-.71.41-.894.78-.184.37-.212.79-.08 1.183.608 1.807.917 3.7.917 5.625 0 .855.695 1.55 1.55 1.55.854 0 1.549-.695 1.549-1.55 0-2.264-.363-4.49-1.08-6.614",
    clipRule: "evenodd"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "cxo0ihrteb",
    width: 39,
    height: 50,
    x: 4,
    y: 0,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M4 0h38.172v50H4V0z",
    clipRule: "evenodd"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cxo0ihrteb)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6C7281",
    fillRule: "evenodd",
    d: "M24.717 34.91c1.807 0 3.603-.37 5.258-1.078-1.323 1.346-3.067 3.16-5.257 5.445-1.901-1.993-3.695-3.897-5.068-5.376 1.616.67 3.316 1.01 5.067 1.01m-4.486-10.603h8.972c2.06 0 4.08-.668 5.74-1.889-.451 5.302-4.86 9.393-10.226 9.393-5.366 0-9.774-4.09-10.226-9.393 1.66 1.221 3.68 1.889 5.74 1.889m8.972-3.1h-8.972c-3.051 0-5.713-2.112-6.423-5.057h21.819c-.71 2.945-3.372 5.057-6.424 5.057m5.86 9.29c-.1-.058-.199-.115-.302-.16 2.152-2.45 3.333-5.563 3.333-8.804 0-.688-.053-1.378-.157-2.054-.022-.137-.062-.27-.124-.404.647-1.242 1.009-2.594 1.075-4.024l3.08-5.391c.215-.376.262-.829.13-1.24-.131-.414-.432-.754-.825-.936L25.423.145c-.413-.193-.886-.193-1.298-.002L19.718 2.17c-.776.356-1.118 1.279-.76 2.054.356.776 1.277 1.118 2.055.761l3.757-1.727 13.67 6.33-1.98 3.463H12.975l-1.978-3.459 3.783-1.74c.376-.172.662-.482.806-.87.143-.388.127-.809-.045-1.185-.173-.376-.483-.662-.872-.806-.39-.144-.81-.127-1.184.046l-5.32 2.447c-.393.18-.695.522-.829.934-.132.413-.084.867.13 1.243l3.081 5.391c.066 1.426.427 2.777 1.073 4.018-.059.129-.098.256-.118.386-.107.684-.161 1.383-.161 2.078 0 3.234 1.18 6.348 3.327 8.796C8.082 33.99 4 40.913 4 48.45c0 .855.695 1.55 1.55 1.55.855 0 1.55-.695 1.55-1.55 0-6.04 3.024-11.569 8.1-14.829 1.124 1.326 3.302 3.651 8.398 8.97.562.584 1.677.584 2.239 0 3.022-3.156 6.957-7.21 8.616-8.826.953.633 1.85 1.363 2.665 2.17.293.29.68.45 1.09.45h.008c.414-.003.802-.166 1.093-.46.292-.293.451-.683.449-1.097-.002-.414-.165-.802-.46-1.094-1.266-1.256-2.692-2.345-4.234-3.236",
    clipRule: "evenodd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6C7281",
    fillRule: "evenodd",
    d: "M24.99 10.817c.541-.602 1.7-2.095 1.7-3.84 0-.723-3.945-.695-3.945 0 0 1.745 1.158 3.238 1.7 3.84.146.162.399.162.545 0",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoliceman);
export default __webpack_public_path__ + "static/media/policeman.8482d73ca2bb1c86113bb8c8fcfc992e.svg";
export { ForwardRef as ReactComponent };